import { EventoService } from './src/services/eventos.services';

export const eventoService = new EventoService();

export default eventoService;
